export const CONFLICT_FIELDS = [
  { key: 'complaint', label: 'CC' },
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'dOB', label: 'DOB' },
  { key: 'age', label: 'Age' },
  { key: 'height', label: 'Height' },
  { key: 'weight', label: 'Weight' },
  { key: 'gender', label: 'Gender' },
]
